export const POST_RESUME = 'POST_RESUME';
export const LIST_RESUME = 'LIST_RESUME';
